module.exports = __webpack_public_path__ + "ath_game_web/img/8.2.75d42c9d.png";